import { render } from "./Patterns.vue?vue&type=template&id=745fca5c&scoped=true"
import script from "./Patterns.vue?vue&type=script&lang=js"
export * from "./Patterns.vue?vue&type=script&lang=js"

import "./Patterns.vue?vue&type=style&index=0&id=745fca5c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745fca5c"]])

export default __exports__